<template>
<div v-if="listAnli">
    <div class="titHd">
        <em>安利理由</em>
        <div class="anli-tip">（ 写安利，争当推主 <a @click="popdown"><i></i></a>）</div>
    </div>
    <ul class="anli-list">
        <li v-for="(item,index) in listAnli" :key=index>            
            <div class="uinfo">
                <div class="tui" v-if="item.user.identity_icon==3">推主</div>
                <div class="uimg"><img :src="item.user.avatar" alt=""></div>
                <div class="uname">
                    <em>{{item.user.nickname}}</em>
                    <p>TA已安利 {{item.recommend_count}} 款游戏</p>
                </div>
                <a class="follow" @click="popdown">+关注TA</a>
            </div>
            <div class="score">
                <div class="starbar">
                    <span :style="{width:starbar(item.star)}"></span>
                </div>
            </div>
            <div class="text" @click="toView(item.pid,item.fid,item.id)">
                <img class="baoer" v-if="item.user.user_tag.title=='老爆er'"  :src='item.user.user_tag.icon_comment' alt="老爆er">
                <span v-html="item.content"></span>        
            </div>
            <div class="info">
                <span class="date" :class="{'edit':item.edittime>0}">{{item.edittime>0?'修改于':''}}
                    {{item.time_str}}
                    <!-- {{ item.location?' • '+item.location:'' }} -->
                </span>               
                <div class="fr">
                    <span class="good" @click="popdown" v-if="item.good==0"></span>
                    <span class="good" @click="popdown" v-else>{{item.good | numFormat}}</span>
                    <!-- <span class="bad" @click="popdown">{{item.oppose}}</span> -->
                    <span class="reply" @click="toView(item.pid,item.fid,item.id)">回复<i v-if="item.posts>0">({{item.posts}})</i></span>
                </div>
            </div>
        </li>
    </ul>  

    <div class="anli-foot">
        <span class="sp1 fl" v-if="listcount" @click="popdown">共有<i>{{listcount}}</i>人安利</span>
        <span class="sp2 fr" @click="popdown">我也要安利</span>
    </div>
    
</div>
</template>

<script>
import Tool from '@/tool/tool';

export default {
    data(){
        return{
            listAnli:null,//安利列表
            listcount:null //列表总数
        }
    },
    mounted(){
        //数据设置
        this.$root.BUS.$on("anli", res => {
            this.listAnli=res.list;
            this.listcount=res.count;
        })
    },
    methods: {
        starbar(num){
            return Tool.ToolPercent(num/5);
        },
        popdown(){
            window.comInit.downTips();
        },
        toView(pid,fid,cid){
            Tool.toView(pid,fid,cid);
        }
    }
}
</script>
